// controllers/photo_row_toggle_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["row", "textRow"]   // row = photo tools, textRow = text tools

    connect() {
        // initial state: text tools visible, photo tools hidden
        this._setVisible(false)

        this._onInspect = (e) => {
            const kind = e.detail?.kind || "Text"
            this._setVisible(kind === "Photo")
        }
        document.addEventListener("ie:inspect", this._onInspect)
    }

    disconnect() {
        document.removeEventListener("ie:inspect", this._onInspect)
    }

    _setVisible(photoActive) {
        if (this.hasRowTarget)     this.rowTarget.classList.toggle("d-none", !photoActive)
        if (this.hasTextRowTarget) this.textRowTarget.classList.toggle("d-none", photoActive)

        this.rowTarget?.setAttribute("aria-hidden", photoActive ? "false" : "true")
        this.textRowTarget?.setAttribute("aria-hidden", photoActive ? "true" : "false")
    }
}